import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class GetHkDateTimeService {
  constructor() {}

  getHKDateAndTime = () => {
    let da = new Date();
    let timeZone = "Asia/Hong_Kong";
    return da.toLocaleString("en-HK", {
      timeZone,
    });
  };
}
